import React, { type FC, Fragment } from 'react';
import { AvmComp } from '../../../../utility/types';

export type SoldMlsNumbersProps = {
  compsFifteenSold: AvmComp[];
};

const smallTxtStyling = 'text-md pt-1 pb-2';

export const SoldMlsNumbers: FC<SoldMlsNumbersProps> = ({
  compsFifteenSold,
}) => {
  return (
    <div className="place-content-start m-2 text-left">
      <h6 className="text-md mt-5 mb-2 font-semibold">
        Top 15 Sold Comps Last MLS #
      </h6>
      <div className="flex flex-wrap">
        {compsFifteenSold?.map((comp, index) => {
          if (comp?.property?.last_mls_id) {
            return (
              <Fragment key={comp?.property?.id}>
                {index !== compsFifteenSold?.length - 1 ? (
                  <p
                    key={index}
                    className={smallTxtStyling}
                  >{`${comp?.property?.last_mls_id},\u00A0`}</p>
                ) : (
                  <p
                    key={index}
                    className={smallTxtStyling}
                  >{`${comp?.property?.last_mls_id}`}</p>
                )}
              </Fragment>
            );
          }
        })}
      </div>
    </div>
  );
};
